import { useEffect, useState } from "react";

import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

import { getCurrentUser } from "../../utils/utils";
import Drawer from "../Drawer";
import { PrivateRoutes } from "../../router/Routes";
import useWindowDimensions from "../../utils/hooks/getWindowDimensions";
import { ReactComponent as NavbarToggler } from "../../static/icons/toggler.svg";
import PaymentPlanModal from "../PaymentPlanModal";

const AuthenticatedLayout = () => {
  const user = getCurrentUser();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const [drawerOpen, setDrawerOpen] = useState(width > 1200);
  const navigate = useNavigate();
  const [paymentModal, setPaymentModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("payment_succeeded")) {
      if (searchParams.get("payment_succeeded") === "true") {
        const storage = JSON.parse(localStorage.getItem("availabilityTracker"));
        localStorage.setItem(
          "availabilityTracker",
          JSON.stringify({
            ...storage,
            user: { ...storage.user, is_payment_active: true },
          })
        );
        setPaymentModal(false);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (user) {
      setPaymentModal(!user.is_payment_active);
    }
  }, []);

  if (user) {
    if (
      Date.parse(user.accessTokenExpire) < new Date().getTime() &&
      Date.parse(user.refreshTokenExpire) < new Date().getTime()
    ) {
      localStorage.removeItem("availabilityTracker");
      return <Navigate to="/login" />;
    }
  } else {
    const state = {};
    if (location.search.includes("invite_code")) {
      state.redirect = location.pathname + location.search;
    }

    return <Navigate to="/login" state={state} />;
  }

  const currentRoute = PrivateRoutes.find((i) => i.path === location.pathname);
  if (currentRoute?.roles && !currentRoute.roles?.includes(user?.role)) {
    return <Navigate to="/employments" />;
  }

  return (
    <div className={`main-container ${paymentModal.open && "payment-overlay"}`}>
      <Navbar
        collapseOnSelect
        expand="xl"
        style={{ background: "rgba(37, 83, 126, 1)", zIndex: 100000 }}
      >
        <Container>
          <Navbar.Brand
            onClick={() => navigate(user ? "/employments" : "/login")}
            className="text-white"
          >
            ready.ninja
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setDrawerOpen((oldVal) => !oldVal)}
          >
            <NavbarToggler />
          </Navbar.Toggle>
        </Container>
      </Navbar>
      <Drawer
        open={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        paymentModalOpen={paymentModal}
      />
      <Container className="canvas-outlet">
        <Outlet key={location.pathname} />
      </Container>
      <PaymentPlanModal
        open={paymentModal}
        onClose={
          searchParams.has("payment_succeeded") && searchParams.get("payment_succeeded") === "true"
            ? () => setPaymentModal(false)
            : null
        }
      />
    </div>
  );
};

export default AuthenticatedLayout;
